import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Lock, User, ArrowLeft } from "lucide-react";
import { getApiUrl } from "@/lib/api";

const API = getApiUrl();

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { username, password });
      localStorage.setItem("admin_token", res.data.token);
      localStorage.setItem("admin_username", res.data.username);
      toast.success("Přihlášení úspěšné");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Chyba přihlášení");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#02120D] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Back link */}
        <a
          href="/"
          className="inline-flex items-center gap-2 text-sm text-[#94A3B8] hover:text-[#EAB308] transition-colors mb-8"
          data-testid="back-to-home"
        >
          <ArrowLeft className="w-4 h-4" />
          Zpět na web
        </a>

        <div className="bg-[#051F16] border border-[#1D4133] rounded-sm p-8">
          <div className="text-center mb-8">
            <h1 className="font-['Playfair_Display'] text-2xl font-bold text-[#F0FDF4]">
              Administrace
            </h1>
            <p className="text-sm text-[#94A3B8] mt-2">Veranda pod Soutokem</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="username" className="text-[#E2E8F0] text-sm">Uživatelské jméno</Label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#94A3B8]" />
                <Input
                  id="username"
                  data-testid="login-username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="pl-10 bg-[#0B2A20] border-[#1D4133] text-[#F0FDF4] placeholder:text-[#94A3B8]/50 rounded-sm focus:ring-[#EAB308] focus:border-[#EAB308]"
                  placeholder="admin"
                  required
                />
              </div>
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="text-[#E2E8F0] text-sm">Heslo</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#94A3B8]" />
                <Input
                  id="password"
                  type="password"
                  data-testid="login-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="pl-10 bg-[#0B2A20] border-[#1D4133] text-[#F0FDF4] placeholder:text-[#94A3B8]/50 rounded-sm focus:ring-[#EAB308] focus:border-[#EAB308]"
                  placeholder="Heslo"
                  required
                />
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit-btn"
              className="w-full bg-[#EAB308] text-[#02120D] hover:bg-yellow-500 rounded-sm font-semibold uppercase tracking-wider py-2.5"
            >
              {loading ? "Přihlašuji..." : "Přihlásit se"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
